var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3167 10C20.3167 15.52 15.8267 20 10.3167 20L10.0369 19.9962C4.64607 19.8478 0.31665 15.4264 0.31665 10C0.31665 4.49 4.79665 0 10.3167 0C15.8267 0 20.3167 4.49 20.3167 10ZM8.09665 12.53L6.35665 10.79C6.05665 10.49 5.57665 10.49 5.27665 10.79C4.97665 11.09 4.97665 11.57 5.27665 11.87L7.61665 14.21C7.91665 14.51 8.39665 14.51 8.69665 14.21L14.7567 8.15C15.0567 7.85 15.0567 7.37 14.7567 7.07C14.4567 6.77 13.9767 6.77 13.6767 7.07L8.09665 12.53Z",
    fill: "#26CD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check2.c4b64fb4972d93701728de83826bf31d.svg";
export { ForwardRef as ReactComponent };